export default __webpack_public_path__ + "static/media/404.817e5c4d.mp4";